import { ComponentType } from 'react';
import {
  HeroConversationMessage,
  ConversationMessageType,
} from '@vs-online-only-app/state';
import TextMessage from './components/message/TextMessage';
import NewChatMessage from './components/message/NewChatMessage';
import EndedChatMessage from './components/message/EndedChatMessage';
import MediaMessage from './components/message/MediaMessage';
import TimestampMessage from './components/message/TimestampMessage';
import NeedSelectedMessage from './components/message/NeedSelectedMessage';
import DepartmentSelectedMessage from './components/message/DepartmentSelectedMessage';
import AssociateTransferMessage from './components/message/AssociateTransferMessage';
import InviteToContactsMessage from './components/message/InviteToContactsMessage';
import ProductMessage from './components/message/ProductMessage';
import InactivityWarningMessage from './components/message/InactivityWarningMessage';
import InactivityEndedMessage from './components/message/InactivityEndedMessage';
import ContactOptedInMessage from './components/message/ContactOptedInMessage';
import CalendarInviteMessage from './components/message/CalendarInviteMessage';
import EmailMessage from './components/message/EmailMessage';

type BaseMessage = {
  message: HeroConversationMessage;
};

export const MessageTypeComponentMap: Record<
  ConversationMessageType,
  ComponentType<BaseMessage>
> = {
  [ConversationMessageType.Text]: TextMessage,
  [ConversationMessageType.OutboundText]: TextMessage,
  [ConversationMessageType.OutboundTextOnly]: TextMessage,
  [ConversationMessageType.Email]: EmailMessage,
  [ConversationMessageType.NewLiveChat]: NewChatMessage,
  [ConversationMessageType.EndedChat]: EndedChatMessage,
  [ConversationMessageType.AutoEndedChat]: EndedChatMessage,
  [ConversationMessageType.Photo]: MediaMessage,
  [ConversationMessageType.Video]: MediaMessage,
  [ConversationMessageType.Timestamp]: TimestampMessage,
  [ConversationMessageType.NeedSelected]: NeedSelectedMessage,
  [ConversationMessageType.DepartmentSelected]: DepartmentSelectedMessage,
  [ConversationMessageType.AssociateTransfer]: AssociateTransferMessage,
  [ConversationMessageType.ContactsInvitationSent]: InviteToContactsMessage,
  [ConversationMessageType.ContactsInvitationAccepted]: InviteToContactsMessage,
  [ConversationMessageType.ContactsOptIn]: ContactOptedInMessage,
  [ConversationMessageType.Product]: ProductMessage,
  [ConversationMessageType.CalendarInvite]: CalendarInviteMessage,
  [ConversationMessageType.InactivityWarning]: InactivityWarningMessage,
  [ConversationMessageType.InactivityEnded]: InactivityEndedMessage,
};
